import { render, staticRenderFns } from "./BlankTemplate.vue?vue&type=template&id=55348208&scoped=true"
import script from "./BlankTemplate.vue?vue&type=script&lang=js"
export * from "./BlankTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55348208",
  null
  
)

export default component.exports